import styled from 'styled-components'
import { icons } from 'common'
import { useOtherUserProfile } from 'hooks/useOtherUserProfile'

export const ProfileCell = ({ address, avatar, username = 'username' }) => {
  const { showOtherUserProfile } = useOtherUserProfile()
  const cellAvatar = avatar || icons.default_avatar_square

  const showProfile = (e) => {
    e.stopPropagation()
    showOtherUserProfile(address, username, cellAvatar)
  }

  return (
    <ProfileWrapper onClick={showProfile}>
      <Avatar avatar={cellAvatar} />
      <Username>{username}</Username>
    </ProfileWrapper>
  )
}

const Username = styled.span`
  font-weight: 700;
  text-decoration: underline;
`

const ProfileWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  &:hover {
    cursor: pointer;
    ${Username}: {
      text-decoration: none;
    }
  }
  &:hover ${Username} {
    text-decoration: none;
  }
`

const Avatar = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background-image: url(${({ avatar }) => avatar});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  margin: 0 5px 0 0;
`
